import React, { useMemo, useCallback, useState, useEffect } from "react";
import TableContainer from "../../../components/Common/TableContainer.js";
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import { Card, CardBody, Button, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { generateColumns } from "../../../custom/Utils/ColumnUtils.js";
import useFetchData from "../../../custom/Utils/UseFetchDataUtils.js";
import usePagination from "../../../custom/Utils/UsePaginationUtils.js";
import { listPageData } from "./GroupFile.js";
import { getRecords } from "../../../services/api.service.js";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../../Style/loaderOverly.js";

const GroupList = () => {
  const navigate = useNavigate();
  const [dataForExport, setDataForExport] = useState([]);

  const [userTypeSelect, setUserTypeSelect] = useState(null);
  const {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  } = listPageData(userTypeSelect?.value);

  const initialPayload = useMemo(() => payload, [userTypeSelect]);

  // pagination
  const {
    page,
    pageSize,
    nextPage,
    previousPage,
    lastPage,
    firstPage,
    handlePageSizeChange,
    setPage,
  } = usePagination();

  // fetch data using the provided payload, page, and page size
  const { data, isLoading, setSearchKeyword, totalCount } = useFetchData(
    initialPayload,
    page,
    pageSize,
    endpoint,
    searchfields
  );

  // handle create action
  const handleCreate = () => navigate(navigatePage.create);

  // handle edit action
  const handleEdit = useCallback(
    (id) => {
      navigate(navigatePage.edit + "/" + id);
    },
    [navigate, navigatePage.edit]
  );

  const handleView = useCallback(
    (id) => {
      navigate(navigatePage.view + "/" + id);
    },
    [navigate, navigatePage.view]
  );

  // columns data
  const columns = useMemo(
    () =>
      generateColumns(data, columnData, handleEdit, handleView, page, pageSize),
    [data, columnData, handleEdit, handleView, page, pageSize]
  );

  // handle page size change callback
  const handlePageSizeChangeWrapper = useCallback(
    (newSize) => {
      handlePageSizeChange(newSize, totalCount);
    },
    [totalCount]
  );

  useEffect(() => {
    const handleExportData = async () => {
      try {
        const responseData = await getRecords(initialPayload, endpoint);
        setDataForExport(responseData.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    handleExportData();
  }, [userTypeSelect]);

  const exportData = dataForExport?.map((item, index) => ({
    "Sr. No": index + 1,
    "USER TYPE":
      item?.user_type === 1
        ? "Bermad User"
        : item?.user_type === 2
        ? "Subcontractor"
        : item?.user_type === 3
        ? "Customer"
        : item?.user_type === 4
        ? "Subcontractor sub user"
        : "N/A",
    COMPANY: item?.company_masters?.company_name || "N/A",
    "FIRST NAME": item?.first_name || "N/A",
    "LAST NAME": item?.last_name || "N/A",
    STATUS:
      item?.is_active === false || item?.is_active === 0
        ? "In-active"
        : "Active",
  }));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumbs title={headerName + " List"} breadcrumbItems={[]} />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleCreate}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create {headerName}
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isLoading={isLoading}
                onSearchInputData={setSearchKeyword}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChangeWrapper}
                nextToPage={nextPage}
                lastToPage={() => lastPage(totalCount)}
                previousToPage={previousPage}
                previousFirstToPage={firstPage}
                totalCount={totalCount}
                customPageSize={pageSize}
                exportData={exportData}
                exportFileName={exportFileName}
                setUserTypeSelect={setUserTypeSelect}
                userTypeSelect={userTypeSelect}
              />
            </CardBody>
          </Card>
          {/* Loader Overlay */}
          {/* {isLoading && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )} */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GroupList;
